import { TagModule } from './../tag/tag.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AutocompleteComponent } from "./autocomplete.component";
import { InputModule } from "../input/input.module";
import { TransitionModule } from "../transition/transition.module";
import { CardModule } from "../card/card.module";
import { HelpTextModule } from "../help-text/help-text.module";
import { StatusModule } from "../status/status.module";
import { LabelModule } from "../label/label.module";
import { FormsModule } from "@angular/forms";

@NgModule({
	declarations: [AutocompleteComponent],
	imports: [
		CommonModule,
		FormsModule,
		InputModule,
		TransitionModule,
		CardModule,
		HelpTextModule,
		StatusModule,
		LabelModule,
		InputModule,
		TagModule
	],
	exports: [AutocompleteComponent]
})
export class AutocompleteModule { }
